import React, { useEffect } from "react";
import { Box, Container, Typography, Link } from "@mui/material";
import { useNav } from "../../context/NavProvider";
import ScriptLoader from "../account/ScriptLoader";
import { useAuth } from "../../context/AuthProvider";
import { useNavigate } from "react-router-dom";
import { useClient } from "../../context/ClientProvider";
import ActionButton from "../account/ActionButton";
function WaysToPay() {
    const { setShowFooter } = useNav();
    const { accessToken } = useAuth();
    const { useGetConfig } = useClient();
    const clientConfig = useGetConfig()?.clientConfig;
    const navigate = useNavigate();
    const waysToPayDataPerClient = clientConfig?.layout?.unauthenticatedPages.findWaysToPay;

    useEffect(() => {
        setShowFooter(true);
    }, [setShowFooter]);

    const handleNavClick = () => {
        if (!accessToken) {
            // Redirect to auth and pass the intended route
            navigate("/auth?redirectTo=/payment");
        } else {
            // User is authenticated, go directly to payment
            navigate("/payment");
        }
    };

    return (
        <>
            <ScriptLoader />
            <Container sx={{ mt: 4, mb: 7 }}>
                <Box>
                    <Typography variant='h1' fontWeight='bold' fontSize={32} sx={{ mb: 4, mt: 4 }}>
                        Ways to pay
                    </Typography>

                    {waysToPayDataPerClient?.payOnlineSection?.enabled && (
                        <Box sx={{ mb: 6 }}>
                            <Typography variant='h2' fontWeight='bold' fontSize={25} sx={{ mb: 3 }}>
                                Pay online
                            </Typography>
                            <ActionButton
                                variant='contained'
                                buttonColor='secondary.main'
                                buttonTextColor='primary.contrastText'
                                borderColor='transparent'
                                hoverColor='primary.contrastText'
                                hoverBorderColor='secondary.main'
                                hoverTextColor='secondary.main'
                                buttonTitle='Make a payment'
                                onClick={handleNavClick}
                                sx={{ mt: 2 }}
                            />
                        </Box>
                    )}

                    {waysToPayDataPerClient?.paymentTelephoneLine?.enabled && (
                        <Box sx={{ mb: 6 }}>
                            <Typography variant='h2' fontWeight='bold' fontSize={26} sx={{ mb: 3 }}>
                                Call the secure payment telephone line
                            </Typography>
                            <Typography sx={{ mb: 2 }}>
                                Get in touch on <Link href={`tel:${waysToPayDataPerClient?.paymentTelephoneLine?.phoneNumber}`}>{waysToPayDataPerClient?.paymentTelephoneLine?.phoneNumber}</Link> to process your payment using our secure payment line.
                            </Typography>
                        </Box>
                    )}

                    {waysToPayDataPerClient?.bankTransferOrStandingOrder?.enabled && (
                        <Box sx={{ mb: 6 }}>
                            <Typography variant='h2' fontWeight='bold' fontSize={26} sx={{ mb: 3 }}>
                                Bank Transfer or Standing Order
                            </Typography>
                            <Typography sx={{ mb: 3 }}>
                                Set up either of these ways to pay using our bank details listed below. You'll need your Reference Number.
                            </Typography>
                            <Typography sx={{ mb: 1.5 }}>
                                Account Name: <b>{waysToPayDataPerClient?.bankTransferOrStandingOrder?.accountName}</b>
                            </Typography>
                            <Typography sx={{ mb: 1.5 }}>
                                Sort Code: <b>{waysToPayDataPerClient?.bankTransferOrStandingOrder?.sortCode}</b>
                            </Typography>
                            <Typography sx={{ mb: 1.5 }}>
                                Account Number: <b>{waysToPayDataPerClient?.bankTransferOrStandingOrder?.accountNumber}</b>
                            </Typography>
                            <Typography sx={{ mb: 1.5 }}>
                                Reference Number: Enter your {clientConfig?.name} Reference Number
                            </Typography>
                            <Typography sx={{ mb: 2 }}>
                                * Please note this is unique to your account so can't be used to pay other {clientConfig?.name} accounts.
                            </Typography>
                        </Box>
                    )}

                    {waysToPayDataPerClient?.directDebitSection?.enabled && (
                        <Box sx={{ mb: 6 }}>
                            <Typography variant='h2' fontWeight='bold' fontSize={26} sx={{ mb: 3 }}>
                                Direct Debit
                            </Typography>
                            <Typography sx={{ mb: 3 }}>{waysToPayDataPerClient?.directDebitSection?.directDebitDescriptionText}</Typography>
                            <img src={waysToPayDataPerClient?.directDebitSection?.url} width={200} alt="Direct Debit Guarantee" style={{ maxWidth: '100%', height: 'auto', marginBottom: 24 }} />
                            <Typography variant='h4' fontWeight='bold' fontSize={26} sx={{ mb: 3, mt: 3 }}>
                                The Direct Debit Guarantee
                            </Typography>
                            <Typography sx={{ mb: 2, whiteSpace: 'pre-line', lineHeight: 1.8 }}>
                                {waysToPayDataPerClient?.directDebitSection?.directDebitGuaranteeText}
                            </Typography>
                        </Box>
                    )}
                    {waysToPayDataPerClient?.chequeOrPostalOrder?.enabled && (
                        <Box sx={{ mb: 6 }}>
                            <Typography variant='h2' fontWeight='bold' fontSize={26} sx={{ mb: 3 }}>
                                Cheque or Postal Order
                            </Typography>
                            <Typography sx={{ mb: 3 }}>
                                Send either a cheque or postal order (adding your full Name and Reference Number on the reverse) to:
                            </Typography>
                            <Typography sx={{ mb: 1.5 }}>{waysToPayDataPerClient?.chequeOrPostalOrder.address1}</Typography>
                            <Typography sx={{ mb: 1.5 }}>{waysToPayDataPerClient?.chequeOrPostalOrder.address2}</Typography>
                            <Typography sx={{ mb: 1.5 }}>{waysToPayDataPerClient?.chequeOrPostalOrder.address3}</Typography>
                            <Typography sx={{ mb: 1.5 }}>{waysToPayDataPerClient?.chequeOrPostalOrder.postCode}</Typography>
                            <Typography sx={{ mb: 2 }}>
                                * Please note that when submitting cheques there may be delays despite all post being processed regularly.
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Container>
        </>
    );
}

export default WaysToPay;
